import React from "react";
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import Home from "../Components/pages/Home";
import NotFound from "../Components/pages/NotFound ";
import ComingSoon from "../Components/pages/ComingSoon";
import Portfolio from "../Components/pages/Portfolio";
import IOSApp from "../Components/pages/IOSApp";
import AndroidApps from "../Components/pages/AndroidApps";
import AboutUsPage from "../Components/pages/AboutUsPage";
import Technologie from "../Components/pages/Technologie";
import ReactNativepage from "../Components/pages/Technologies/ReactNativepage";
import Fluttercustompage from "../Components/pages/Technologies/Fluttercustompage";
import Kotlinpage from "../Components/pages/Technologies/Kotlinpage";
import Swiftpage from "../Components/pages/Technologies/Swiftpage";
import Contactus from "../Components/pages/Contactus";
import PrivacyPolicy from "../Components/pages/PrivacyPolicy";
import TermsConditions from "../Components/pages/TermsConditions";
import CrossPlatform from "../Components/pages/CrossPlatform";
import Careers from "../Components/pages/Careers";
import CaseStudies from "../Components/pages/CaseStudies";
import PortfolioDetails from "../Components/layouts/portfolio/PortfolioDetails";
import JobDetails from "../Components/layouts/Careers/JobDetails";




// Import your pages/components

const router = createBrowserRouter([
    {
        path: "/",
        element: <Home />,

    },
    {
        path: "/Portfolio",
        element: <Portfolio />,

    },
    {
        path: "/IOSApp",
        element: <IOSApp />,

    },
    {
        path: "/Androidapps",
        element: <AndroidApps />,

    },
    {
        path: "/AboutUs",
        element: <AboutUsPage />,

    },
    {
        path: "/Technologie",
        element: <Technologie />,

    },
    {
        path: "/Technologie/Flutter",
        element: <Fluttercustompage />,
    },
    {
        path: "/Technologie/ReactNative",
        element: <ReactNativepage />,
    },
    {
        path: "/Technologie/Kotlin",
        element: <Kotlinpage />,
    },
    {
        path: "/Technologie/Swift",
        element: <Swiftpage />,
    },
    {
        path: "/Contactus",
        element: <Contactus />,
    },
    {
        path: "/PrivacyPolicy",
        element: <PrivacyPolicy />,
    },
    {
        path: "/Terms",
        element: <TermsConditions />,
    },
    {
        path: "/CrossPlatform",
        element: <CrossPlatform />,
    },
    {
        path: "/Careers",
        element: <Careers />,
    },
    {
        path: "/CaseStudies",
        element: <CaseStudies />,
    },

    {
        path: "/portfolio/:slug",
        element: <PortfolioDetails />,
    },

    {
        path: "/jobs/:slug",
        element: <JobDetails />,
    },


    // 👇 MOST IMPORTANT
    {
        path: "*",
        element: <NotFound />,
    }
]);

export default function Rout() {
    return <RouterProvider router={router} />;
}
